

















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';


/**
 * Composant de représentation d'un item sous forme de carte.
 */
@Component
export default class ShopItemCard extends Vue {
	/** Propriétés */
	// Un item
	@Prop()
	item!: any;

	@Prop()
	itemInCart!: any;

	@Prop()
	handleItemClick!: (poolid: number, itemId: number) => Promise<void>;

	@Prop()
	poolId!: number;

	/** Attributs */
	isActionLoading: boolean = false;
		
	/** Méthodes */
	async onItemClick() {
		this.isActionLoading = true;
		try {
			 if (this.item.remaining > 0 || this.item.maxBooking == -1) {
			this.item.isSelected =  !this.item.isSelected;
			await this.handleItemClick(this.poolId,this.item.id);
			 }
			this.isActionLoading = false;
		}
		catch (error) {
			alert(error);
			this.isActionLoading = false;
			throw error;
		}
	}


}
